import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=510e0713&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('510e0713')) {
      api.createRecord('510e0713', component.options)
    } else {
      api.reload('510e0713', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=510e0713&", function () {
      api.rerender('510e0713', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GbeC5qQzx6Xf/JS/pricehelp.vue"
export default component.exports